module.exports = __webpack_public_path__ + "img/jilotepec.cfd1dd04.jpg";